import React from 'react'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import eclosBrandLogo from '../../../assets/img/logos/brands/logo-eclos-brand-white.svg'
import mainBackgroundImage from '../../../assets/img/banner-eclos-brand/eclos-brand-background-1.png'
import homeImg from '../../../assets/img/banner-eclos-brand/eclos-brand-home-img.png'
import catalogImgBanner from '../../../assets/img/banner-eclos-brand/eclos-brand-catalog-img.png'
import catalogMiniGridImgBanner from '../../../assets/img/banner-eclos-brand/eclos-brand-mini-grid.png'
import catalogBgImage from '../../../assets/img/banner-eclos-brand/eclos-brand-catalog-bg.png'
import { changeCenter } from '../../../store/centers/actions'
import { getLocalizedUrl } from '../../../store/ui/reducers'

import Translation from '../../global/Translation'
import LocalizedLink from '../../global/LocalizedLink'
import { FormattedHTMLMessage } from 'react-intl'
import Button from '../../global/Button'
import { getSelectedCenter } from '../../../store/centers/reducers'

const mapStateToProps = state => {
    return {
        localizedUrl: (intl, routeId, params = {}) => getLocalizedUrl(state, intl, routeId, params),
        selectedCenter: getSelectedCenter(state)
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onChangeCenter: (centerId, urlCallback) => {
            dispatch({ type: 'CHANGE_CENTER_BY_USER', center: centerId })
            dispatch(changeCenter(centerId, urlCallback))
            dispatch({ type: 'REMEMBERED_CENTER' })
        }
    }
}

class BannerEclosBrand extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            isMobile: window.innerWidth < 768
        }
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleResize)
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize)
    }

    handleResize = () => {
        this.setState({ isMobile: window.innerWidth < 768 })
    }

    render() {
        const {
            isHomeSlideView,
            isPriaorityCustomer,
            className,
            isAustralianCenter,
            canViewEclosBrandInEurope,
            isSelectedCenterAvailableToBuyEclosProducts
        } = this.props
        const { isMobile } = this.state

        // ─── Determina si el center actual es uno de los nuevos habilitados ───
        // Tiene prioridad sobre la lógica de cliente prioritario para el CTA
        const isLocalCenterEnabled = isSelectedCenterAvailableToBuyEclosProducts

        // ─── Decide si el banner debe mostrarse en absoluto ───
        const shouldShowBanner = isPriaorityCustomer || isAustralianCenter || canViewEclosBrandInEurope || isLocalCenterEnabled

        // ─── Bloques reutilizables ───

        const homeImgBlock = (
            <div className="img-block">
                <div>
                    <img src={homeImg} alt="Colors collection" />
                </div>
            </div>
        )

        const catalogPriorityImgBlock = (
            <div className="img-block">
                <div>
                    <img src={catalogImgBanner} alt="Colors collection" />
                </div>
            </div>
        )

        const secondHeadingBlock = (
            <div className="second-heading-block">
                <FormattedHTMLMessage id="inlayer_full_body_design_tech" defaultMessage="Inlayer <b>full body</b> design tech" />
                <FormattedHTMLMessage id="superior_heat_resistance" defaultMessage="<b>Superior heat</b> resistance" />
                <FormattedHTMLMessage id="zero_silica" defaultMessage="<b>Zero</b> silica" />
            </div>
        )

        // CTA para centers nuevos habilitados:
        // enlaza al catalog del propio center, sin cambio de center ni redirección a HQ
        const btnLocalCenterBlock = (
            <div className="btn-custom-block">
                <LocalizedLink routeId="ROUTE_CATALOG" queryString="?type[0]=SLAB&brand[0]=ECLOS" params={{ outlet: '' }}>
                    <Button inverted>
                        <Translation id="discover_eclos" defaultMessage="Discover ÉCLOS" />
                    </Button>
                </LocalizedLink>
            </div>
        )

        // CTA para clientes no prioritarios en centers no habilitados (comportamiento original)
        const btnBlockNonPriorityCustomers = (
            <div className="btn-custom-block">
                <LocalizedLink routeId="ROUTE_CATALOG" queryString="?type[0]=SLAB&brand[0]=ECLOS" params={{ outlet: '' }}>
                    <Button inverted>
                        <Translation id="discover_eclos" defaultMessage="Discover ÉCLOS" />
                    </Button>
                </LocalizedLink>
            </div>
        )

        // CTA para clientes prioritarios: redirige a HQ (center 1100)
        // Solo se usa cuando el center actual NO es uno de los nuevos habilitados
        const btnPriorityBlock = (
            <div className="btn-custom-block">
                {this.props.selectedCenter == 1100 ? (
                    <LocalizedLink routeId="ROUTE_CATALOG" queryString="?type[0]=SLAB&brand[0]=ECLOS" params={{ outlet: '' }}>
                        <Button inverted>
                            <Translation id="discover_eclos" defaultMessage="Discover ÉCLOS" />
                        </Button>
                    </LocalizedLink>
                ) : (
                    <Button
                        inverted
                        onClick={() => {
                            let baseUrl = this.props.localizedUrl(this.props.intl, 'ROUTE_CATALOG', { outlet: '' })
                            while (baseUrl.endsWith('?')) {
                                baseUrl = baseUrl.slice(0, -1)
                            }
                            const queryString = '?type[0]=SLAB&brand[0]=ECLOS'
                            this.props.onChangeCenter(1100, `${baseUrl}${queryString}`)
                        }}
                    >
                        <Translation id="discover_eclos" defaultMessage="Discover ÉCLOS" />
                    </Button>
                )}
            </div>
        )

        const mainHeadingBlock = (
            <div className="main-heading-block">
                <h2>
                    <Translation id="the_next_generation_of_mineral_surface" defaultMessage="the next generation of mineral surface" />
                </h2>
            </div>
        )

        const brandBlock = (
            <div className="brand-block">
                <img src={eclosBrandLogo} alt="Éclos Brand" />
            </div>
        )

        const exclusiveColorsBlock = (
            <div className="exclusive-colors">
                <span>
                    <Translation id="exclusive_colors" defaultMessage="Exclusive colors" />
                </span>
            </div>
        )

        // ─── Resuelve qué CTA mostrar según prioridad ───
        // 1. Center local habilitado → CTA local (sin cambio de center)
        // 2. Cliente prioritario o Europa → CTA HQ
        // 3. Resto → CTA non-priority (sin compra / coming soon)
        const resolvedCtaBlock = isLocalCenterEnabled
            ? btnLocalCenterBlock
            : (isPriaorityCustomer || canViewEclosBrandInEurope)
                ? btnPriorityBlock
                : btnBlockNonPriorityCustomers

        // El bloque de condiciones se muestra si el center está habilitado, es prioritario o Europa
        const conditionsBlock = (
            <div className="eclos-conditions-block">
                <span>
                    <Translation
                        id="the_purchase_of_eclos_materials_is_subject_to_conditions"
                        defaultMessage="The purchase of ÉCLOS materials is subject to conditions."
                    />
                </span>
            </div>
        )

        const showConditions = isLocalCenterEnabled || isPriaorityCustomer || canViewEclosBrandInEurope

        const mobileDiscoverEclosBlock = (
            <div className="mobile-discover-block">
                <div>
                    <img src={catalogMiniGridImgBanner} alt="Discover ÉCLOS" />
                </div>
                <div>{resolvedCtaBlock}</div>
            </div>
        )

        if (!shouldShowBanner) return null

        return (
            <React.Fragment>
                {isHomeSlideView ? (
                    <div
                        className="banner__eclos"
                        style={{
                            backgroundImage: `url(${mainBackgroundImage})`,
                            backgroundRepeat: 'no-repeat',
                            backgroundSize: 'cover',
                            backgroundPosition: 'right',
                            height: '100%',
                            width: '100%'
                        }}
                    >
                        <div className="home-main-content">
                            <div className="left-block">
                                {exclusiveColorsBlock}
                                {brandBlock}
                                {mainHeadingBlock}
                                {secondHeadingBlock}
                                {showConditions && conditionsBlock}
                                {!isMobile && resolvedCtaBlock}
                            </div>
                            <div className="right-block">
                                {isMobile ? mobileDiscoverEclosBlock : homeImgBlock}
                            </div>
                        </div>
                    </div>
                ) : (
                    <div
                        className="banner__eclos"
                        style={{
                            backgroundImage: `url(${catalogBgImage})`,
                            backgroundRepeat: 'no-repeat',
                            backgroundSize: 'cover',
                            backgroundPosition: 'center center',
                            height: '100%',
                            width: '100%'
                        }}
                    >
                        <div className={`catalog-main-content ${!isPriaorityCustomer && !isLocalCenterEnabled ? 'is-no-priority' : ''} ${className}`}>
                            <div className="left-block">
                                {brandBlock}
                                {mainHeadingBlock}
                                {!(isMobile && !isPriaorityCustomer && !isLocalCenterEnabled) && secondHeadingBlock}
                            </div>
                            <div className="right-block">
                                <div className="exclusive-colors-block">{exclusiveColorsBlock}</div>
                                {!isMobile ? (
                                    <div className="catalog-img-banner">
                                        {catalogPriorityImgBlock}
                                        {resolvedCtaBlock}
                                    </div>
                                ) : (
                                    <div style={{ width: '100%' }}>{mobileDiscoverEclosBlock}</div>
                                )}
                            </div>
                        </div>
                    </div>
                )}
            </React.Fragment>
        )
    }
}

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(BannerEclosBrand))